import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import useSEO from '../../hooks/useSEO';

const PageTitle = ({ 
  titleKey, 
  fallbackTitle, 
  pageKey, // Nouvelle prop pour référencer les données SEO
  customTitle,
  customDescription,
  customKeywords,
  noIndex = false 
}) => {
  const { t } = useTranslation();
  
  // Utiliser le hook SEO avancé si pageKey est fourni
  useSEO({
    titleKey: pageKey ? `seo.${pageKey}.title` : titleKey,
    descriptionKey: pageKey ? `seo.${pageKey}.description` : null,
    customTitle: customTitle,
    customDescription: customDescription,
    customKeywords: pageKey ? t(`seo.${pageKey}.keywords`, { defaultValue: customKeywords }) : customKeywords,
    noIndex: noIndex
  });

  // Fallback pour la compatibilité avec l'ancien système
  useEffect(() => {
    if (!pageKey && (titleKey || fallbackTitle)) {
      const title = titleKey ? t(titleKey) : fallbackTitle;
      if (title) {
        document.title = title;
      }
    }
  }, [titleKey, fallbackTitle, t, pageKey]);

  return null; // Ce composant ne rend rien visuellement
};

export default PageTitle; 